import request from '@/utils/request';

// 查询任务列表
export function getTaskList(query) {
  return request({
    url: 'admin/platform/task/list',
    method: 'post',
    data: query
  });
}

// 新增任务
export function createTask(data) {
  return request({
    url: 'admin/platform/task/create',
    method: 'post',
    data: data
  });
}

// 修改任务
export function updateTask(data) {
  return request({
    url: 'admin/platform/task/update',
    method: 'post',
    data: data
  });
}

// 删除任务
export function deleteTask(taskId) {
  return request({
    url: 'admin/platform/task/delete/' + taskId,
    method: 'post'
  });
}
export function getTaskDetail(taskId) {
  return request({
    url: "admin/platform/task/detail/".concat(taskId),
    method: 'get'
  });
}
export function getTaskStatisticsList(params) {
  return request({
    url: 'admin/platform/task/statistics/list',
    method: 'get',
    params: params
  });
}
export function getTaskStatisticsDetailList(params) {
  return request({
    url: 'admin/platform/task/statistics/detail',
    method: 'get',
    params: params
  });
}
export function getTaskStatisticsProductList(params) {
  return request({
    url: 'admin/platform/product/browse/statistics',
    method: 'get',
    params: params
  });
}

// 获取用户每日任务统计列表
export function getUserTaskDailyList(params) {
  return request({
    url: 'admin/platform/task/userDaily/list',
    method: 'get',
    params: params
  });
}

// 获取用户任务完成记录列表
export function getUserTaskLogList(params) {
  return request({
    url: 'admin/platform/task/userLog/list',
    method: 'get',
    params: params
  });
}